import { useMainStore } from "~/store/mainState";

export default defineNuxtPlugin(async nuxtApp => {
    await useMainStore().tryInit();
});
